import React from "react";
import ServiceSection2 from "../../service/section2/ServiceSection2";
// import LeftAboutSection2 from "./section2Left/LeftAboutSection2";
// import RightAboutSection2 from "./section2Right/RightAboutSection2";

const AboutSection2 = () => {
  return (
    <div id="act">
    <div className=" lg:mx-0 lg:flex ">
      {/* <LeftAboutSection2 />
      <RightAboutSection2 /> */}
      <ServiceSection2/>
    </div>
    </div>
  );
};

export default AboutSection2;

